import { useCouponConfig } from 'hooks/useCouponConfig';

export const useHolidayDiscount = () => {
  const currentTime = Date.now();

  const { coupon, isRemoteConfigFetched } = useCouponConfig();

  return {
    IS_HOLIDAY_DISCOUNT_ACTIVE:
      coupon?.enable &&
      currentTime >= coupon?.start_time &&
      currentTime < coupon?.end_time,

    HOLIDAY_DISCOUNT_PERCENTAGE: coupon?.discount_percentage ?? 0,
    HOLIDAY_DISCOUNT_COUPON: coupon?.coupon_code ?? '',
    isRemoteConfigFetched
  };
};

// import envConfig from './envConfig';
// export const IS_HOLIDAY_DISCOUNT_ACTIVE =
//   envConfig('isHolidayDiscountActive') === 'true' || false;

// export const HOLIDAY_DISCOUNT_PERCENTAGE = Number(
//   envConfig('holidayDiscountPercentage')
// );
// export const HOLIDAY_DISCOUNT_COUPON = envConfig('holidayDiscountCoupon');
// console.log('discount enabled', IS_HOLIDAY_DISCOUNT_ACTIVE);
// console.log('discount percentage', HOLIDAY_DISCOUNT_PERCENTAGE);
// console.log('discount coupon', HOLIDAY_DISCOUNT_COUPON);

// hooks/useHolidayDiscount.ts

// function convertEDTToEpoch(dateStr: string) {
//   // Example: '2025-07-01 03:06:00'
//   const edtDate = new Date(`${dateStr} EDT`);
//   return edtDate.getTime(); // returns epoch in milliseconds
// }

// // Usage
// const epoch = convertEDTToEpoch('2025-07-01 06:05:00');
// console.log('Epoch (ms):', epoch);
// console.log('Epoch (s):', Math.floor(epoch / 1000));

// function convertPDTToEpoch(dateStr: string) {
//   // Example: '2025-07-01 03:06:00 PDT'
//   const pdtDate = new Date(`${dateStr} PDT`);
//   return pdtDate.getTime(); // milliseconds
// }

// // Usage
// const epoch2 = convertPDTToEpoch('2025-06-30 03:10:00');
// console.log('Epoch (ms):', epoch2);
// console.log('Epoch (s):', Math.floor(epoch / 1000));
